import axios from 'axios'
import Config from '../../config/app'

export default {
  async loginService () {
    const response = await axios.get(`${Config.services.login}`)
    return response.data
  }
}
